import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CompactPicker } from 'react-color';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import {
  getDefaultColors,
  showAlertModal } from './../../../../redux/helpers/';
import { saveState } from './../../../../redux/actions/entities/io';
import {
  changeSpineBackgroundColor,
} from './../../../../redux/actions/entities/cover';

import PageBackgroundColor from './page-background-color/PageBackgroundColor';
import { coversWithText } from './../../../../helpers/coverHelper';


class Colors extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      opened: true,
      spineColorOpened: false,
      backgroundColorOpened: true,
      color: '#FFFFFF',
    };
    this.handleSpineColorChange = debounce(this.handleSpineColorChange, 500);
    this.clicked = false;
  }

  componentDidUpdate() {
    const {
      context,
      isSavedBook,
    } = this.props;

    const { backgroundColorOpened, opened } = this.state;
    const ifConsumerAndNewBook = context === 'consumer' && backgroundColorOpened && isSavedBook && !this.clicked;
    if (ifConsumerAndNewBook) {
      this.setState({
        backgroundColorOpened: !backgroundColorOpened,
        opened: !opened,
      });
    }
  }

  changeDropDown = () => {
    const { opened } = this.state;
    const {
      backgroundType, lang, selectedBackgroundColor, backgroundImage, context,
    } = this.props;

    if ((backgroundType === '' && (selectedBackgroundColor === '' || backgroundImage === '')) || (backgroundType === 'tematikus' && backgroundImage === '')) {
      return showAlertModal(lang.title_notice, lang.select_background);
    }
    return this.setState({
      opened: !opened,
      backgroundColorOpened: false,
      spineColorOpened: false,
    });
  }

  changeSpineColorDropDown = () => {
    const { spineColorOpened } = this.state;
    this.setState({
      backgroundColorOpened: false,
      spineColorOpened: !spineColorOpened,
      opened: true,
    });
  }

  changeBackgroundColorDropDown = () => {
    this.clicked = true;
    const { backgroundColorOpened } = this.state;
    this.setState({
      spineColorOpened: false,
      backgroundColorOpened: !backgroundColorOpened,
      opened: true,
    });
  }

  colorPicker(spineColor, defaultColor, handler) {
    return (
      <CompactPicker
        triangle="hide"
        color={spineColor === '' ? defaultColor : spineColor}
        colors={getDefaultColors()}
        onChange={handler}
        ref={(node) => { this.node = node; }}
      />
    );
  }

  handleSpineColorChange = (color) => {
    const { hex } = color;
    this.props.dispatch(changeSpineBackgroundColor(hex));
    this.props.dispatch(saveState());
    this.setState({
      opened: true,
    });
  };


  render() {
    const {
      opened,
      backgroundColorOpened,
      spineColorOpened,
      color: defaultTextColor,
    } = this.state;

    const {
      pageId,
      pageOrder,
      lang,
      isCover,
      spine,
      coverType,
      pages,
    } = this.props;

    const coverWithSpine = coversWithText().includes(coverType);
    const {
      backgroundColor,
    } = spine;

    const backgroundShow = backgroundColorOpened ? 'show' : '';
    const spineShow = spineColorOpened ? 'show' : '';
    return (
      <div className="colorWrapper">
        <div className={`marginWrapper ${backgroundShow}`}>
          <button ref={(backgroundButton) => { this.backgroundButton = backgroundButton; }} type="button" className="btn green-btn margin-btn" onClick={this.changeBackgroundColorDropDown.bind(this)}>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12">
              <path d="M13,0V12H24V0ZM0,12H11V0H0Z" />
            </svg>
            {lang.background_color}
          </button>
          <div className={`dropdown-menu background-picker circle-picker ${backgroundShow}`}>
            <PageBackgroundColor
              pageId={pageId}
              pageOrder={pageOrder}
              lang={lang}
              pages={pages}
            />
          </div>
        </div>
        { coverWithSpine && isCover ?
          <div className={`marginWrapper ${spineShow}`}>
            <button ref={(spineButton) => { this.spineButton = spineButton; }} className="btn green-btn margin-btn right-side" type="button" onClick={this.changeSpineColorDropDown.bind(this)}>
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 24 16">
                <path d="M24,2H13V0H11V2H0V14H11v2h2V14H24ZM11,13H1V3H11Zm12,0H13V3H23Z" />
              </svg>
              {lang.top_menu_book_spine}
            </button>
            <div className={`dropdown-menu  sketch-picker ${spineShow}`}>
              { this.colorPicker(backgroundColor, defaultTextColor, this.handleSpineColorChange) }
            </div>
          </div>
        : ' '}
        { opened ? <div onClick={this.changeDropDown.bind(this)} className="overlay" /> : ''}
      </div>
    );
  }
}

Colors.defaultProps = {
  isCover: false,
  pageId: 0,
  pageOrder: 0,
  lang: {},
  spine: {},
  coverType: '',
  context: '',
  backgroundType: '',
  selectedBackgroundColor: '',
  backgroundImage: '',
  dispatch: () => {},
  isSavedBook: false,
};

Colors.propTypes = {
  isCover: PropTypes.bool,
  pageId: PropTypes.number,
  pageOrder: PropTypes.number,
  lang: PropTypes.object,
  spine: PropTypes.object,
  coverType: PropTypes.string,
  context: PropTypes.string,
  backgroundType: PropTypes.string,
  selectedBackgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  dispatch: PropTypes.func,
  isSavedBook: PropTypes.bool,
};

export default connect(state => ({
  spine: state.entities.cover.spine,
  context: state.bookProperties.context,
  backgroundType: state.editorUI.bookProperties.backgroundType,
  selectedBackgroundColor: state.editorUI.bookProperties.backgroundColor,
  backgroundImage: state.editorUI.bookProperties.backgroundImage,
  isSavedBook: state.editorUI.isSavedBook,
}))(Colors);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/Colors.jsx